// 导入必要的包

import { Progress } from 'element-ui' //前端的样式组件
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import * as echarts from 'echarts'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2' //此插件可以使得前端页面能够给复制
import './utils/rem' //用来调整窗口大小的
import VueSocketIO from 'vue-socket.io'
import socketIO from 'socket.io-client'
import i18n from './lang';
import appConfig from '@/config'

const socketUrl = appConfig.socketUrl

// 从各种来源获取token的函数
function getAuthToken() {
    // 首先检查localStorage
    let token = localStorage.getItem('jwt-token');

    // 如果localStorage中没有，检查URL参数
    if (!token) {
        const urlParams = new URLSearchParams(window.location.search);
        token = urlParams.get('token');

        if (token) {
            // 存储token供后续使用
            localStorage.setItem('jwt-token', token);

            // 清理URL，移除token参数
            const url = new URL(window.location);
            url.searchParams.delete('token');
            window.history.replaceState({}, document.title, url.toString());
        }
    }

    return token;
}

const authToken = getAuthToken();

Vue.use(new VueSocketIO({
    debug: true,
    connection: socketIO(socketUrl , {
        autoConnect:false,
        transports:['websocket'],
        reconnectionAttempts: 1,
        reconnectionDelay: 60000,
        auth: {
            token: authToken ? `Bearer ${authToken}` : null
        }
    })
}))

const setup = {
    async install (Vue) {
        Vue.use(ElementUI, { locale })
        Vue.prototype.$echarts = echarts
    }
}

Vue.use(VueClipboard)
Vue.use(setup)
Vue.use(Progress)


//阻止示显示生产模式的消息
Vue.config.productionTip = false

Vue.config.silent = true;

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js